import { CustomTag } from 'src/components'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

interface CustomStatusColumnProps {
  isStatusOk: boolean
  isCancelled?: boolean
}

const CustomStatusColumn: FC<CustomStatusColumnProps> = (props) => {
  const { t } = useTranslation()
  const { isStatusOk, isCancelled = false } = props

  const status = {
    COMPLETED: { label: t('developers.Completed'), type: 'success' },
    PENDING: { label: t('Deposits.Pending'), type: 'processing' },
    CANCELLED: { label: t('general.Cancelled'), type: 'error' }
  }[isCancelled ? 'CANCELLED' : isStatusOk ? 'COMPLETED' : 'PENDING']

  return <CustomTag text={status.label} type={status.type} />
}

export default CustomStatusColumn
